import { themeText } from './theme-text.js';
import { themeNyanCat } from './theme-nyan-cat.js';
import { themeCircle } from './theme-circle.js';
import { themeOnTracks } from './theme-on-tracks.js';

export const themes = {
  text: themeText,
  'nyan-cat': themeNyanCat,
  circle: themeCircle,
  'on-tracks': themeOnTracks
};
